import { render, staticRenderFns } from "./LeaveCommentWasRestored.vue?vue&type=template&id=364c864c"
import script from "./LeaveCommentWasRestored.vue?vue&type=script&lang=js"
export * from "./LeaveCommentWasRestored.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports